var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { apiUpdateClientNegotiateMessage } from '@/actions/ClientRfpNegotiateActions';
import { messageFieldName } from '@/components/modules/Chat/ChatForm/ChatForm';
import { notify, wrapNotifyError } from '@/helpers/action';
import { wrapDispatch } from '@/utils/actions/dispatch';
import { RFP_NEGOTIATE_MESSAGE_STATUS_DRAFT, RFP_NEGOTIATE_MESSAGE_STATUS_PUBLIC, RFP_NEGOTIATE_MESSAGE_STATUSES, } from '@/utils/constants/rfp/rfpNegotiate/rfpNegotiateMessage/status';
import { RFP_NEGOTIATE_TYPE_BUDGET, RFP_NEGOTIATE_TYPE_START_DATE, RFP_NEGOTIATE_TYPE_END_DATE, } from '@/utils/constants/rfp/rfpNegotiate/type';
/**
 * 条件相談メッセージの更新 関連
 */
export const useRfpClientOneNegotiateSubmitMessage = (args) => {
    const { fetchNegotiateList, id, resetUpdatedReadCount, selectedId } = args;
    const dispatch = useDispatch();
    /**
     * 条件相談メッセージ更新
     */
    const onSubmitMessage = useCallback((onSubmitMessageArgs, form) => __awaiter(void 0, void 0, void 0, function* () {
        const { status, type, values } = onSubmitMessageArgs;
        const { description, viewRequestId } = values;
        yield wrapNotifyError(() => __awaiter(void 0, void 0, void 0, function* () {
            var _a;
            yield wrapDispatch(dispatch, apiUpdateClientNegotiateMessage({
                json: {
                    description,
                    status,
                    type,
                },
                path: { id, view_request_id: viewRequestId },
            }, {}));
            // トースト表示
            const notifyMessage = (_a = RFP_NEGOTIATE_MESSAGE_STATUSES.find((v) => v.value === status)) === null || _a === void 0 ? void 0 : _a.message;
            if (notifyMessage) {
                notify(`${notifyMessage}しました`);
            }
            // フォームの値をリセット
            form.batch(() => {
                var _a;
                form.change(messageFieldName, '');
                (_a = form.resetFieldState) === null || _a === void 0 ? void 0 : _a.call(form, messageFieldName);
            });
            // データ引き直し
            yield fetchNegotiateList({
                rfpId: id,
                selectedViewRequestId: selectedId,
            });
            // データ引き直し後 既読数のリセット
            resetUpdatedReadCount();
        }));
    }), [id, fetchNegotiateList, dispatch, resetUpdatedReadCount, selectedId]);
    /**
     * 下書き保存: 予算
     */
    const onClickDraftBudget = useCallback((values, form) => __awaiter(void 0, void 0, void 0, function* () {
        yield onSubmitMessage({
            status: RFP_NEGOTIATE_MESSAGE_STATUS_DRAFT.value,
            type: RFP_NEGOTIATE_TYPE_BUDGET.value,
            values,
        }, form);
    }), [onSubmitMessage]);
    /**
     * 下書き保存: PJ開始時期
     */
    const onClickDraftStartDate = useCallback((values, form) => __awaiter(void 0, void 0, void 0, function* () {
        yield onSubmitMessage({
            status: RFP_NEGOTIATE_MESSAGE_STATUS_DRAFT.value,
            type: RFP_NEGOTIATE_TYPE_START_DATE.value,
            values,
        }, form);
    }), [onSubmitMessage]);
    /**
     * 下書き保存: PJ終了時期
     */
    const onClickDraftEndDate = useCallback((values, form) => __awaiter(void 0, void 0, void 0, function* () {
        yield onSubmitMessage({
            status: RFP_NEGOTIATE_MESSAGE_STATUS_DRAFT.value,
            type: RFP_NEGOTIATE_TYPE_END_DATE.value,
            values,
        }, form);
    }), [onSubmitMessage]);
    /**
     * メッセージ送信: 予算
     */
    const onClickSubmitBudget = useCallback((values, form) => __awaiter(void 0, void 0, void 0, function* () {
        yield onSubmitMessage({
            status: RFP_NEGOTIATE_MESSAGE_STATUS_PUBLIC.value,
            type: RFP_NEGOTIATE_TYPE_BUDGET.value,
            values,
        }, form);
    }), [onSubmitMessage]);
    /**
     * メッセージ送信: PJ開始時期
     */
    const onClickSubmitStartDate = useCallback((values, form) => __awaiter(void 0, void 0, void 0, function* () {
        yield onSubmitMessage({
            status: RFP_NEGOTIATE_MESSAGE_STATUS_PUBLIC.value,
            type: RFP_NEGOTIATE_TYPE_START_DATE.value,
            values,
        }, form);
    }), [onSubmitMessage]);
    /**
     * メッセージ送信: PJ終了時期
     */
    const onClickSubmitEndDate = useCallback((values, form) => __awaiter(void 0, void 0, void 0, function* () {
        yield onSubmitMessage({
            status: RFP_NEGOTIATE_MESSAGE_STATUS_PUBLIC.value,
            type: RFP_NEGOTIATE_TYPE_END_DATE.value,
            values,
        }, form);
    }), [onSubmitMessage]);
    return {
        onClickDraftBudget,
        onClickDraftEndDate,
        onClickDraftStartDate,
        onClickSubmitBudget,
        onClickSubmitEndDate,
        onClickSubmitStartDate,
    };
};
